import {
  faBook,
  faBookOpen,
  faBoxTaped,
  faCalendar,
  faCalendarCheck,
  faCalendarDays,
  faCamera,
  faCameraRetro,
  faChartArea,
  faChartSimple,
  faClipboardCheck,
  faClipboardList,
  faCreditCard,
  faDatabase,
  faDumbbell,
  faEnvelope,
  faFile,
  faGear,
  faHeartbeat,
  faHome,
  faLink,
  faLocationDot,
  faMoneyBill,
  faPlug,
  faQuestion,
  faRobot,
  faRunning,
  faSitemap,
  faTable,
  faTag,
  faUser,
  faUserGear,
  faUserGroup,
  faUserPen,
  faUserTie,
  faUsers,
  faUtensils,
  faVideo,
  faWeight,
  faWeightScale,
} from '@fortawesome/pro-regular-svg-icons';

export const defaultIcon = faFile;

export const routesExtraData = {
  'Data Loads': {
    icon: faDatabase,
    reactRoute: '/data-loads',
    enabled: true,
  },
  Stripe: {
    reactRoute: '/stripe/payment-plans',
    icon: faCreditCard,
  },
  Messages: {
    icon: faEnvelope,
    reactRoute: '/messages',
  },
  Appointments: {
    icon: faBook,
    reactRoute: '/appointments',
  },
  'Time Card': {
    icon: faBook,
    reactRoute: '/time-tracking',
  },
  Lifecycle: {
    icon: faHeartbeat,
    reactRoute: '/lifecycle',
  },
  Products: {
    icon: faBoxTaped,
    reactRoute: '/products',
    children: [
      {
        id: 'products',
        reactRoute: '/products',
        name: 'Products',
        enabled: true,
      },
      {
        id: 'manage-inventory',
        reactRoute: '/products/inventory',
        name: 'Inventory',
        enabled: true,
      },
    ],
  },
  Reports: {
    icon: faChartArea,
    reactRoute: '/reports',
  },
  'Franchise Fees': {
    icon: faMoneyBill,
    reactRoute: '/franchise-fees',
    enabled: true,
  },
  Dashboard: {
    icon: faHome,
    reactRoute: '/dashboard',
  },
  Plans: {
    icon: faClipboardList,
    reactRoute: '/workout-plans',
  },
  Exercises: {
    icon: faDumbbell,
    reactRoute: '/exercises',
  },
  Groups: {
    icon: faUsers,
    reactRoute: '/groups',
  },
  Clients: {
    icon: faUser,
    reactRoute: '/clients',
  },
  Packages: {
    icon: faBoxTaped,
    route: '/fbm/packages',
  },
  Services: {
    icon: faClipboardList,
    route: '/fbm/services',
  },
  Onboarding: {
    icon: faUser,
    reactRoute: '/onboarding',
  },
  Emails: {
    icon: faEnvelope,
    reactRoute: '/emails',
  },
  'Platform Hierarchy': {
    icon: faSitemap,
    reactRoute: '/sites/hierarchy',
  },
  Sites: {
    icon: faLocationDot,
    reactRoute: '/sites',
    enabled: true,
  },
  Schedule: {
    icon: faCalendar,
    children: [
      {
        id: 'calendar',
        route: '/fbm/schedule',
        name: 'Calendar',
        enabled: true,
      },
      {
        id: 'visits',
        reactRoute: '/fbm/visits',
        name: 'Visits',
        enabled: true,
      },
      {
        id: 'members',
        reactRoute: '/fbm/scheduled-members',
        name: 'Recurring Members',
        enabled: true,
      },
      {
        id: 'services',
        reactRoute: '/fbm/services',
        name: 'Services',
        enabled: true,
      },
      {
        id: 'packages',
        reactRoute: '/fbm/packages',
        name: 'Packages',
        enabled: true,
      },
      {
        id: 'locations',
        reactRoute: '/fbm/locations',
        name: 'Locations',
        enabled: true,
      },
      {
        id: 'schedules',
        reactRoute: '/fbm/schedules',
        name: 'Availability Schedules',
        enabled: true,
      },
    ],
  },
  'Site Configuration': {
    icon: faGear,
    route: '/dashboard/trainer/custom',
    children: [
      {
        id: 'customize platform',
        route: '/dashboard/trainer/custom',
        name: 'Customize Platform',
        reactRoute: '/settings/platform',
        enabled: true,
      },
      {
        id: 'manage-roles',
        route: '/dashboard/roles-management',
        name: 'Staff Roles',
        reactRoute: '/site-configuration/roles',
        enabled: true,
      },
      {
        id: 'navigation',
        reactRoute: '/site-configuration/navigation',
        name: 'Navigation Menu Settings',
        enabled: true,
      },
      {
        id: 'habits',
        reactRoute: '/site-configuration/habits',
        name: 'Habits',
        enabled: true,
      },
      {
        id: 'tags',
        reactRoute: '/site-configuration/tags',
        name: 'Tags',
        enabled: true,
      },
      {
        id: 'lifecycle',
        reactRoute: '/lifecycle',
        name: 'Lifecycle',
        enabled: true,
      },
      {
        id: 'reports',
        reactRoute: '/site-configuration/reports',
        name: 'Reports',
        enabled: true,
      },
      {
        id: 'resources',
        reactRoute: '/site-configuration/resources',
        name: 'Resources',
        enabled: true,
      },
    ],
  },
  Account: {
    icon: faUserGear,
  },
  Booking: {
    icon: faBook,
  },
  Automations: {
    icon: faRobot,
    reactRoute: '/automations',
  },
  Journal: {
    icon: faBook,
    reactRoute: '/me/journal',
  },
  Activity: {
    icon: faRunning,
    reactRoute: 'activity'
  },
  Performance: {
    icon: faChartSimple,
    reactRoute: '/me/performance',
  },
  Snapshot: {
    icon: faCamera,
    reactRoute: '/me/snapshots',
  },
  Measurements: {
    icon: faWeightScale,
    reactRoute: '/me/health',
  },
  Tags: {
    icon: faTag,
    reactRoute: '/tags',
  },
  Resources: {
    icon: faWeight,
    reactRoute: '/resources',
  },
  Assessments: {
    icon: faClipboardCheck,
    reactRoute: '/trainer/assessments/',
  },
  'My Stuff': {
    icon: faUser,
  },
  'My Measurements': {
    icon: faWeightScale,
    reactRoute: '/me/measurements',
  },
  Visits: {
    icon: faCalendarCheck,
    reactRoute: '/me/visits',
  },
  'My Assessments': {
    icon: faClipboardCheck,
    reactRoute: '/me/assessments',
  },
  'My Videos': {
    icon: faVideo,
    reactRoute: '/me/videos',
  },
  Dependents: {
    icon: faUserGroup,
    reactRoute: '/me/dependents',
  },
  'My Progress Photos': {
    icon: faCameraRetro,
    reactRoute: '/me/progress-photos',
  },
  'My Nutrition': {
    icon: faUtensils,
    reactRoute: '/me/nutrition',
  },
  'My Resources': {
    icon: faBookOpen,
    reactRoute: '/me/resources',
  },
  'My Packages': {
    icon: faBoxTaped,
    reactRoute: '/me/packages',
  },
  'My Groups': {
    icon: faUsers,
    reactRoute: '/me/groups',
  },
  'My Rep Maxes': {
    icon: faWeightScale,
    reactRoute: '/me/rep-maxes',
  },
  'Point of Sale': {
    icon: faCreditCard,
    reactRoute: '/pos-config/settings',
  },
  'Edit Profile': {
    icon: faUserPen,
    reactRoute: '/me/profile',
  },
  'Trainer Info': {
    icon: faUserTie,
    reactRoute: '/me/profile',
  },
  'My Workout Plans': {
    icon: faBoxTaped,
    reactRoute: '/me/workout-plans',
  },
  Trainers: {
    icon: faUsers,
    reactRoute: '/staff',
  },
  'Connected Apps': {
    icon: faPlug,
    reactRoute: '/me/apps',
  },
  'My Connected Apps': {
    icon: faPlug,
    reactRoute: '/me/apps',
  },
  'My Products': {
    icon: faBoxTaped,
    reactRoute: '/me/products',
  },
  Support: {
    icon: faQuestion,
    reactRoute: '/support',
  },
  Links: {
    icon: faLink,
    reactRoute: '/links',
  },
  Events: {
    icon: faCalendarDays,
    reactRoute: '/events',
  },
  Videos: {
    icon: faVideo,
    reactRoute: '/videos',
  },
  'Measurement Reports': {
    icon: faTable,
    reactRoute: '/health/reports',
  },
  'Customize Platform': {
    icon: faGear,
    reactRoute: '/settings/platform',
  },
};

export const clientRoutesExtraData = {
  Packages: {
    icon: faBoxTaped,
    externalLink: false,
    reactRoute: '/purchase/packages',
  },
  Exercises: {
    icon: faDumbbell,
    reactRoute: '/finders/exercises',
    externalLink: false,
  },
  Groups: {
    icon: faUsers,
    reactRoute: '/finders/groups',
    externalLink: false,
  },
  Plans: {
    icon: faClipboardList,
    reactRoute: '/finders/plans',
    externalLink: false,
  },
  Products: {
    icon: faBoxTaped,
    reactRoute: '/purchase/products',
    externalLink: false,
  },
  Booking: {
    icon: faBook,
    externalLink: true,
    reactRoute: '/a/booking',
  },
};
